import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa436118&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=aa436118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa436118",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/header/product/index.vue
// module id = null
// module chunks = 